import { render, staticRenderFns } from "./FragmentEmbed.vue?vue&type=template&id=2f1938a2"
import script from "./FragmentEmbed.vue?vue&type=script&lang=ts"
export * from "./FragmentEmbed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports